import { useOnSuccessQuery } from '@wyz/utils';
import { useManageCustomers } from '~/common/api';
// eslint-disable-next-line @wyz/module/bad-module-import
import { CustomerSelectorHelpers } from '~/connect/helpers';
import { BaseCustomerSelector } from '~/purchase/components';
import { usePurchaseContext } from '~/purchase/context';

function SecondaryCustomerSelector() {
  const { state, handlers } = usePurchaseContext();

  const managerCustomers = useManageCustomers({
    getChildren: {
      args: {
        id: state.primaryCustomer?.id as string,
      },
      enabled: Boolean(state.primaryCustomer?.id),
      refetchOnMount: true,
    },
  });

  useOnSuccessQuery(managerCustomers.getChildren, (response) => {
    const selected = response.data.find(
      (customer) => customer.id === state.selectedSecondaryCustomerId,
    );

    handlers.setSecondaryCustomerId(selected?.id || undefined);
  });

  const secondaryCustomer =
    state.selectedSecondaryCustomerId &&
    state.primaryCustomer &&
    state.secondaryCustomer
      ? state.secondaryCustomer
      : undefined;

  return (
    <BaseCustomerSelector
      key={state.selectedSecondaryCustomerId}
      isLoading={
        managerCustomers.getChildren.isProcessing ||
        state.loading.isLoadingSecondaryCustomer
      }
      isDisabled={
        !managerCustomers.getChildren.isSuccess ||
        managerCustomers.getChildren.data.data.length === 0 ||
        state.loading.isLoadingSecondaryCustomer ||
        !state.primaryCustomer?.id
      }
      value={
        secondaryCustomer
          ? CustomerSelectorHelpers.customerToOption({
              ...secondaryCustomer,
              deliveryInformation: {
                city: secondaryCustomer.deliveryInformation?.city ?? '',
                zipCode: secondaryCustomer.deliveryInformation?.zipCode ?? '',
                country: {
                  currencyId:
                    secondaryCustomer.deliveryInformation?.country
                      ?.currencyId ?? 0,
                },
              },
            })
          : undefined
      }
      options={
        state.primaryCustomer?.id
          ? managerCustomers.getChildren.data?.data.map((item) =>
              CustomerSelectorHelpers.customerToOption(item),
            ) || []
          : []
      }
      onChange={(selectedOption) => {
        handlers.setSecondaryCustomerId(selectedOption?.value);
      }}
      name={'secondary-customer'}
    />
  );
}

export default SecondaryCustomerSelector;
